import { z } from 'zod';
/**
 * @fileoverview Defines Zod schemas for credit deduction operations.
 * These schemas are used for runtime validation in the backend.
 *
 * @note
 * This schema is part of a special developer debugging mode.
 */
/**
 * Zod schema for the credit deduction request body.
 * Validates the data sent from the client to the API.
 */
export const creditDeductionRequestSchema = z.object({
    /**
     * The number of credits to deduct. Must be a positive integer.
     */
    amount: z.number().int().positive(),
    /**
     * A string identifying the source of the deduction.
     */
    source: z.string().min(1),
});
//# sourceMappingURL=deduction.schemas.js.map